module.exports = "<div class=\"featured-work-container\">\n  <h1>Featured Work</h1>\n  <div class=\"featured-work-inner\">\n    <portfolio-display class=\"portfolio-display\" *ngFor=\"let work of featuredWork\" [element]=\"work\"></portfolio-display>\n  </div>\n  <div class=\"button-container\">\n    <button class=\"btn-view-more clickable\" [routerLink]=\"['/portfolio']\">View More</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/components/home/featured-work/featured-work.component.html
// module id = ../../../../../src/app/components/home/featured-work/featured-work.component.html
// module chunks = 1